import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import pic from "../assets/images/propic.png";
import { db } from "../components/Firebase";
import chat from "../assets/images/ilustrator.png";
import search1 from "../assets/images/search.png";
import moment from "moment";

const Chat = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  //console.log("users", users);

  const searachMethod = () => {
    let searchUsers = users;
    return searchUsers.filter((i) => {
      return i?.name?.toLowerCase().includes(search?.toLowerCase());
    });
  };
  useEffect(() => {
    getAllUsers();
  }, []);
  const getAllUsers = () => {
    db.collection("chatRooms")
      .get()
      .then((docs) => {
        let newUsers = [];
        docs.forEach((user) => {
          newUsers.push(user.data());
        });
        setUsers(newUsers);
      });
  };
  return (
    
<div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12" style={{ paddingBottom: "40px" }}>
        <h1 style={{ textAlign: "center" }}>Chat</h1>
        <input placeholder="Chat Search" class="form-control" value={search} onChange={(e) => { setSearch(e.target.value); }} />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" style={{height: "400px", overflowY: 'scroll'}}>
        <table class="table table-striped table-bordered">
          <tbody>
            {searachMethod().sort((a,b)=>moment(b.lastMessage).valueOf() - moment(a.lastMessage).valueOf()).map((i) => {
              return (
            <tr onClick={() => { navigate("chatpages", { state: { item: i } }); }}>
              <td style={{justifyContent:'space-between',flex:1,display:'flex'}} >
                <span>{i.name}</span>
              <span>{moment(i.lastMessage).format("DD MMM")}</span>
              </td>
            </tr>
            );
            })}
          </tbody>
        </table>
      </div>
      <div class="col-md-8">
        <div>
          {location.pathname === "/chats" ? (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <div>
              <img
                width={300}
                height={250}
                style={{ borderRadius: 30 }}
                src={chat}
              />
              <div>
                <h5 style={{ textAlign: "center" }}>
                  Send and receive messages,
                  <br /> click atleast one to have a chat
                </h5>
              </div>
            </div>
          </div>
        ) : (
          <Outlet />
        )}
        </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default Chat;
